/* Scoped enhancement: keep every item visible if this script is unavailable. */
if (!customElements.get('sf-package-disclosure')) {
  customElements.define('sf-package-disclosure', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.button = this.querySelector('.sf-package-disclosure__toggle');
        if (!this.button) return;
        this.setExpanded(false);
        this.dataset.ready = 'true';
        this.querySelector('[data-package-actions]').hidden = false;
        this.button.addEventListener('click', () => {
          this.setExpanded(this.button.getAttribute('aria-expanded') !== 'true');
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          if (event.target instanceof Element && this.contains(event.target)) {
            const row = event.target.closest('.sfmod-package__item');
            if (row && [...row.parentElement.children].indexOf(row) >= 5) this.setExpanded(true);
          }
        }, options);
      });
    }
    setExpanded(expanded) {
      this.dataset.expanded = String(expanded);
      this.button.setAttribute('aria-expanded', String(expanded));
      this.button.querySelector('[data-package-label]').textContent = expanded ? 'Show less' : 'Show more';
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}

